import React from "react";
import {Event} from "../../../../cp/components/Comet";
import {useEventContext} from "../EventContext";

export default () => {
    const {eventDispatch} = useEventContext();

    const onUpdate = (data) => eventDispatch((event) => ({...event, ...data}));

    return (
        <>
            <Event event="update:event" handler={(data) => onUpdate(data)} />
            <Event event="update:event/moduleActivity" handler={(data) => onUpdate({moduleActivity: data})} />
            <Event event="update:event/moduleAuth" handler={(data) => onUpdate({moduleAuth: data})} />
            <Event event="update:event/moduleBranding" handler={(data) => onUpdate({moduleBranding: data})} />
            <Event event="update:event/moduleComment" handler={(data) => onUpdate({moduleComment: data})} />
            <Event event="update:event/moduleEpisode" handler={(data) => onUpdate({moduleEpisode: data})} />
            <Event event="update:event/moduleInformation" handler={(data) => onUpdate({moduleInformation: data})} />
            <Event event="update:event/moduleMain" handler={(data) => onUpdate({moduleMain: data})} />
            <Event event="update:event/modulePage" handler={(data) => onUpdate({modulePage: data})} />
            <Event event="update:event/moduleQuestion" handler={(data) => onUpdate({moduleQuestion: data})} />
            <Event event="update:event/moduleQuiz" handler={(data) => onUpdate({moduleQuiz: data})} />
            <Event event="update:event/moduleSettings" handler={(data) => onUpdate({moduleSettings: data})} />
            <Event event="update:event/moduleTheme" handler={(data) => onUpdate({moduleTheme: data})} />
            <Event event="update:event/moduleTwitter" handler={(data) => onUpdate({moduleTwitter: data})} />
        </>
    );
}
